import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialPalette } from '@nutrien/cxp-components';

const toggleStyle = (color: string, bgColor: string = color, noOpacity = false) => ({
  color: `${color} !important`,
  backgroundColor: `${noOpacity ? bgColor : bgColor + '1F'} !important`,
});

const useStyles = makeStyles(() =>
  createStyles({
    deficiencyContentContainer: {
      marginTop: '16px',
    },
    greenButton: toggleStyle(MaterialPalette.primary.main),
    yellowButton: toggleStyle(MaterialPalette.warning.main),
    orangeButton: toggleStyle('#F07B2A'),
    redButton: toggleStyle(MaterialPalette.error.main),
    whiteButton: toggleStyle(MaterialPalette.grey[50], MaterialPalette.grey[700], true),
  }),
);

export { useStyles };
export default useStyles;
